import { TemplatePage } from '../TemplatePage';

export const ManagePlanTemplates = () => {
  return <TemplatePage type="Plan" title="Plan" />;
};
